<template>
  <section class="anchor slider" id="slider">
    <swiper ref="slider" :options="swiperOption">
      <swiper-slide class="slider__item slider__item-1">
        <div class="container">
          <div class="slider__content">
            <div
              class="slider__content-title"
              v-html="$t('home.slider.slide_1.title')"
            ></div>
            <div
              class="slider__content-subtitle"
              v-html="$t('home.slider.slide_1.subtitle')"
            ></div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="slider__item slider__item-2">
        <div class="container">
          <div class="slider__content">
            <div
              class="slider__content-title"
              v-html="$t('home.slider.slide_2.title')"
            ></div>
            <div
              class="slider__content-subtitle"
              v-html="$t('home.slider.slide_2.subtitle')"
            ></div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="slider__item slider__item-3">
        <div class="container">
          <div class="slider__content">
            <div
              class="slider__content-title"
              v-html="$t('home.slider.slide_3.title')"
            ></div>
            <div
              class="slider__content-subtitle"
              v-html="$t('home.slider.slide_3.subtitle')"
            ></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

export default {
  name: "Slider",
  data() {
    return {
      sliderInterval: null,
      swiperOption: {
        loop: true,
        speed: 500,
        autoplay: 4000
      }
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  mounted() {
    this.sliderInterval = setInterval(() => {
      this.$refs.slider.$swiper.slideNext();
    }, 4000);
  },
  destroyed() {
    clearInterval(this.sliderInterval);
  }
};
</script>
